import { defineMessages } from 'react-intl';
var messages = defineMessages({
    FromCompany: {
        id: 'FromCompany',
        defaultMessage: 'From company',
    },
    ToCompany: {
        id: 'ToCompany',
        defaultMessage: 'To company',
    },
    FromLegalEntity: {
        id: 'FromLegalEntity',
        defaultMessage: 'From legal entity',
    },
    ToLegalEntity: {
        id: 'ToLegalEntity',
        defaultMessage: 'To legal entity',
    },
    ToRelation: {
        id: 'ToRelation',
        defaultMessage: 'To relation',
    },
    Relation: {
        id: 'Relation',
        defaultMessage: 'Relation',
    },
    Assignment: {
        id: 'Assignment',
        defaultMessage: 'Assignment',
    },
    Date: {
        id: 'Date',
        defaultMessage: 'Date',
    },
    User: {
        id: 'User',
        defaultMessage: 'User',
    },
    Resource: {
        id: 'Resource',
        defaultMessage: 'Resource',
    },
    OriginalQuantity: {
        id: 'OriginalQuantity',
        defaultMessage: 'Original quantity',
    },
    BilledQuantity: {
        id: 'BilledQuantity',
        defaultMessage: 'Billed quantity',
    },
    InForfait: {
        id: 'InForfait',
        defaultMessage: 'In forfait',
    },
    BilledAmount: {
        id: 'BilledAmount',
        defaultMessage: 'Billed amount',
    },
    IntraCompanyAmount: {
        id: 'IntraCompanyAmount',
        defaultMessage: 'Intra company amount',
    },
    IntraCompanyUnitPrice: {
        id: 'IntraCompanyUnitPrice',
        defaultMessage: 'Intra company unit price',
    },
    AddToIntraCompanyInvoice: {
        id: 'AddToIntraCompanyInvoice',
        defaultMessage: 'Add to intra company invoice',
    },
    MakeInvoiceProposal: {
        id: 'MakeInvoiceProposal',
        defaultMessage: 'Make invoice proposal',
    },
    MakeInvoiceProposals: {
        id: 'MakeInvoiceProposals',
        defaultMessage: 'Make invoice proposals',
    },
    IntraCompanyBilling: {
        id: 'IntraCompanyBilling',
        defaultMessage: 'Intra company billing',
    },
    OnlyInvoicedRegistrations: {
        id: 'OnlyInvoicedRegistrations',
        defaultMessage: 'Only invoiced registrations',
    },
    NeverInvoiceRegistration: {
        id: 'NeverInvoiceRegistration',
        defaultMessage: 'Never invoice registration',
    },
    Undo: {
        id: 'Undo',
        defaultMessage: 'Undo',
    },
    DoNotIntraCompanyBillRegistrationConfirm: {
        id: 'DoNotIntraCompanyBillRegistrationConfirm',
        defaultMessage: "Are you sure you don't want to bill this registration to another own company",
    },
    NoRelationConfiguredInCompany: {
        id: 'NoRelationConfiguredInCompany',
        defaultMessage: 'There is no relation configured on the company',
    },
    ShowOnlyNeverIntraCompany: {
        id: 'ShowOnlyNeverIntraCompany',
        defaultMessage: 'Show only never intra company registrations',
    },
    ResetFilters: {
        id: 'ResetFilters',
        defaultMessage: 'Reset filters',
    },
    ShowMore: {
        id: 'ShowMore',
        defaultMessage: 'Show more',
    },
    BillNonBillableRegistrations: {
        id: 'BillNonBillableRegistrations',
        defaultMessage: 'Make non-billable registrations billable',
    },
    BackgroundJobQueued: {
        id: 'BackgroundJobQueued',
        defaultMessage: 'A background job has started. Click here to monitor the progress.',
    },
    Processing: {
        id: 'Processing',
        defaultMessage: 'Processing',
    },
});
export default messages;
